<div class="page">
  <div class="content page-header">
    <h1 data-qa="page-title">Anleitungen</h1>
  </div>
  <div class="content page-content">
    <ufla-anleitungen-list></ufla-anleitungen-list>
  </div>
</div>
